<template>
  <div>
    <apexchart type="bar" :options="chartOptions" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import RebanhoDeRecria from "../../class/RebanhoDeRecria";
import RebanhoDeReproducao from "../../class/RebanhoDeReproducao";
import DadosDespesasAnimais from "../../class/DadosDespesasAnimal.js";
import DadosDasDespesas from "../../class/DadosDasDespesas.js";
import DadosDespesasManutencao from "../../class/DadosDespesasManutencao.js";
import DadosDespesasServicos from "../../class/DadosDespesasServicos.js";
import DadosDasReceitas from "../../class/DadosDasReceitas.js";
import DadosRecursosAnimais from "../../class/DadosRecursosAnimais.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";
import DadosRecursosPastagensOutros from "../../class/DadosRecursosPastagensOutros.js";
import ReceitaAnual from "../../class/ReceitaAnual.js";
import ReceitaAnualAbate from "../../class/ReceitaAnualAbate.js";
import OutrasReceitas from "../../class/OutrasReceitas.js";

var dados = [];

export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => {
    return {
      simulation: "",
      chartOptions: {
        chart: {
          id: "vuechart-example"
        },
        colors: ["#F279A6"],
        xaxis: {
          categories: [
            "Receita",
            "Despesas",
            "Custo operacional",
            "Margem bruta",
            "Margem operacional"
          ]
        },
        yaxis: [
          {
            labels: {
              formatter: function(val) {
                return val.toFixed(2);
              }
            }
          }
        ],
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return parseFloat(val.toFixed(2)).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL"
            });
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              var valor = val;
              if (typeof valor !== "undefined") {
                return parseFloat(valor.toFixed(2)).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                });
              } else return valor;
            }
          }
        }
      },
      series: [
        {
          name: "",
          data: dados
        }
      ],
      largura: "100%"
    };
  },

  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    preencherGrafico: function() {
      this.$db.simulation
        .get({ code: this.simulation.code }, dado => {
          var manutencao = new DadosDespesasManutencao(dado.dadosManutencao);
          var despesas = new DadosDasDespesas(dado.dadosDasDespesas);
          var servicos = new DadosDespesasServicos(dado.dadosDespesasServicos);
          var despesasAnimais = new DadosDespesasAnimais(
            dado.dadosDespesasAnimal
          );
          var receitas = new DadosDasReceitas(dado.proLabore);
          var pastagens = new DadosRecursosPastagensOutros(
            dado.dadosRecursosPastagensOutros
          );
          var instalacoes = new DadosRecursosInstalacoes(
            dado.dadosRecursosInstalacoes
          );
          var maquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
          var recursosAnimais = new DadosRecursosAnimais(
            dado.dadosRecursosAnimais
          );
          var rebanhoReproducao = new RebanhoDeReproducao(
            dado.rebanhoReproducao
          );
          var abate = new ReceitaAnualAbate(dado.bovinoAbate);
          var outro = new ReceitaAnual(dado.bovinoOutro);
          var recria = new RebanhoDeRecria(dado.rebanhoRecria);
          var outrasReceitas = new OutrasReceitas(dado.outrasReceitas);

          var biblioteca = [
            BibliotecaDeCalculos.RecursosPastagens(pastagens),
            BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
            BibliotecaDeCalculos.RecursosMaquinas(maquinas),
            BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
            BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
            BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
            BibliotecaDeCalculos.Despesas(despesas),
            BibliotecaDeCalculos.DadosDasReceitas(receitas),
            BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
            BibliotecaDeCalculos.DespesasServicos(servicos),
            BibliotecaDeCalculos.RebanhoDeVenda(abate, outro),
            BibliotecaDeCalculos.RebanhoDeRecria(recria),
            BibliotecaDeCalculos.OutrasReceitas(outrasReceitas),
            BibliotecaDeCalculos.CalculosDosGraficos(
              BibliotecaDeCalculos.RecursosPastagens(pastagens),
              BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
              BibliotecaDeCalculos.RecursosMaquinas(maquinas),
              BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
              BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
              BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
              BibliotecaDeCalculos.Despesas(despesas),
              BibliotecaDeCalculos.DadosDasReceitas(receitas),
              BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
              BibliotecaDeCalculos.DespesasServicos(servicos),
              BibliotecaDeCalculos.RebanhoDeVenda(abate, outro),
              BibliotecaDeCalculos.RebanhoDeRecria(recria),
              BibliotecaDeCalculos.OutrasReceitas(outrasReceitas)
            )
          ];
          return biblioteca;
        })
        .then(
          g => (
            (dados[0] = parseFloat(
              (
                g[10].calculaValorTotalVenda() +
                g[12].outrasReceitasBovinocultura()
              ).toFixed(2)
            )),
            (dados[1] = g[13].totalDespesas()),
            (dados[2] = g[13].custoOperacional()),
            (dados[3] = g[13].margemBruta()),
            (dados[4] = g[13].margemOperacional())
          )
        );
    }
  }
};
</script>
<style scoped>
</style>